
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import AddShop from '../../AddShop';

interface AddShopDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onShopAdded?: () => void;
  refreshShops?: () => Promise<void>;
}

const AddShopDialog: React.FC<AddShopDialogProps> = ({ 
  isOpen, 
  setIsOpen,
  onShopAdded,
  refreshShops
}) => {
  const handleShopAdded = () => {
    setIsOpen(false);
    
    // Call both callbacks if provided
    if (onShopAdded) onShopAdded();
    if (refreshShops) refreshShops();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[600px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Add Shop</DialogTitle>
        </DialogHeader>
        <AddShop 
          onShopAdded={handleShopAdded} 
          onCancel={() => setIsOpen(false)} 
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddShopDialog;
